export default function rebelSlider(config) {
    import("./slider").then((module) => {
        module.default(config);
    });
}
